class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.hotspots = Array.from(this.querySelectorAll('[data-shop-the-look-hotspot]'));
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onResize = this.positionCards.bind(this);

    this.hotspots.forEach((hotspot) => {
      const button = hotspot.querySelector('[data-shop-the-look-trigger]');
      if (!button) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleHotspot(hotspot);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('resize', this.onResize, { passive: true });
    this.positionCards();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('resize', this.onResize);
  }

  setExpanded(hotspot, expanded) {
    const button = hotspot.querySelector('[data-shop-the-look-trigger]');
    if (button) button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  toggleHotspot(hotspot) {
    const isActive = hotspot.classList.contains('is-active');
    this.closeAll();
    if (!isActive) {
      hotspot.classList.add('is-active');
      this.setExpanded(hotspot, true);
      this.positionCard(hotspot);
    }
  }

  closeAll() {
    this.hotspots.forEach((hotspot) => {
      hotspot.classList.remove('is-active');
      this.setExpanded(hotspot, false);
    });
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeAll();
      return;
    }

    const hotspot = event.target.closest('[data-shop-the-look-hotspot]');
    if (!hotspot) this.closeAll();
  }

  onKeyDown(event) {
    if (event.key === 'Escape') this.closeAll();
  }

  positionCards() {
    this.hotspots.forEach((hotspot) => this.positionCard(hotspot));
  }

  positionCard(hotspot) {
    const media = hotspot.closest('[data-shop-the-look-media]');
    const card = hotspot.querySelector('[data-shop-the-look-card]');
    if (!media || !card) return;

    hotspot.classList.remove(
      'shop-the-look__hotspot--card-top',
      'shop-the-look__hotspot--card-left',
      'shop-the-look__hotspot--card-right'
    );

    const mediaRect = media.getBoundingClientRect();
    const hotspotRect = hotspot.getBoundingClientRect();
    const spaceBelow = mediaRect.bottom - hotspotRect.bottom;
    const spaceAbove = hotspotRect.top - mediaRect.top;
    const spaceRight = mediaRect.right - hotspotRect.right;
    const spaceLeft = hotspotRect.left - mediaRect.left;
    const cardWidth = Math.min(240, window.innerWidth - 30);
    const cardHeight = 80;

    if (spaceBelow < cardHeight + 20 && spaceAbove > spaceBelow) {
      hotspot.classList.add('shop-the-look__hotspot--card-top');
    } else if (spaceRight < cardWidth / 2 && spaceLeft > spaceRight) {
      hotspot.classList.add('shop-the-look__hotspot--card-left');
    } else if (spaceLeft < cardWidth / 2 && spaceRight > spaceLeft) {
      hotspot.classList.add('shop-the-look__hotspot--card-right');
    }
  }
}

customElements.define('shop-the-look', ShopTheLook);
